import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		header: {
			textTransform: "none" as const,
			paddingTop: 5,
			marginBottom: 5,
			fontSize: 16,
			fontWeight: "bold",
		},
		avatar: {
			marginRight: 15,
		},
		icon: {
			height: 35,
			width: 35,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			marginRight: 15,
			color: "none",
		},
		row: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			minHeight: 60,
			paddingLeft: 10,
			paddingRight: 10,
		},
		left: {
			borderRight: "1px solid lightgray",
			[theme.breakpoints.only("md")]: {
				borderLeft: "none",
			},
		},
		right: {
			borderLeft: "1px solid lightgray",
			[theme.breakpoints.only("md")]: {
				borderLeft: "none",
			},
		},
	} satisfies Record<string, CSSObject>;
};
